import axios from '@/configs/Axios'

function setWithExpiry(key, value, ttl, userId) {
    const now = new Date()

    const item = {
        value: value,
        uid: userId,
        expiry: now.getTime() + ttl
    }
    localStorage.setItem(key, JSON.stringify(item))
}

const payloadParams = (payload) => {
    if(payload) {
        let reqData = "";
        Object.keys(payload).forEach(key => {
            reqData += key + "=" + payload[key] + "&"
        })
        reqData = reqData.substr(0, reqData.lastIndexOf("&"))
        return '?'+reqData
    } else return ''
}

const state = () => ({
    graphPopup: false,
    historyPopup: false,
    graphList: [],
    graphCount: null,
    historyList: [],
    historyCount: null,
    formSetting: null,
    contract: null,
    payPopup: false,
    payHistoryPopup: false,
    payHistoryList: [],
    payData: null,
    payContractUid: null,
    payHistoryCount: null
})

const mutations = {
    SET_PAY_UID(state, value) {
        state.payContractUid = value
    },
    SET_PAY_DATA(state, value) {
        state.payData = value
        state.payPopup = true
    },
    SET_PAY_POPUP(state, value) {
        state.payPopup = value
    },
    SET_PAY_HISTORY_COUNT(state, value) {
        state.payHistoryCount = value
    },
    SET_PAY_HISTORY(state, payload) {
        state.payHistoryList = state.payHistoryList.concat(payload)
    },
    SET_PAY_HISTORY_POPUP(state, value) {
        state.payHistoryPopup = value
    },
    SET_POPUP_CONTRACT(state, value) {
        state.contract = value
    },
    SET_GRAPH_POPUP(state, value) {
        state.graphPopup = value
    },
    SET_GRAPH_COUNT(state, value) {
        state.graphCount = value
    },
    SET_FORM_SETTING (state, value) {
        state.formSetting = value
    },
    SET_GRAPH_LIST(state, payload) {
        state.graphList = state.graphList.concat(payload)
    },
    CLEAR_GRAPH_LIST(state) {
        state.graphList = []
        state.graphCount = null
    },
    SET_HISTORY_POPUP(state, value) {
        state.historyPopup = value
    },
    SET_HISTORY_LIST(state, payload) {
        state.historyList = state.historyList.concat(payload)
    },
    CLEAR_HISTORY_LIST(state) {
        state.historyList = []
        state.historyCount = null
    },
    SET_HISTORY_COUNT(state, value) {
        state.historyCount = value
    },
}

const actions = {
    getGraphList({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`/finance/contracts/payment_schedule/${ payloadParams(payload) }`)
                .then(({data}) => {
                    if(typeof data === 'object') {
                        commit('SET_GRAPH_LIST', data.results)
                        commit('SET_GRAPH_COUNT', data.count)
                        resolve(data)
                    } else
                        resolve(false)
                })
                .catch((error) => { reject(error) })
        })
    },
    fetchFormSetting ({ commit, rootState }) {
        return new Promise((resolve, reject) => {
            let dataStorage = JSON.parse(localStorage.getItem('form_setting'));
            const now = new Date(),
                userId = rootState.user.user.profileId;

            if(dataStorage && dataStorage.uid !== userId) {
                localStorage.removeItem('form_setting')
                dataStorage = false
            }

            if (!dataStorage || now.getTime() >= dataStorage.expiry) {
                axios.get(`/common/settings/`)
                    .then(({data}) => {
                        const time = now.getTime() + (1000 * 60 * 60 * 24)
                        setWithExpiry('form_setting', data[0], time, userId)

                        commit('SET_FORM_SETTING', data[0])
                        resolve(data[0])
                    })
                    .catch((error) => { reject(error) })
            } else {
                commit('SET_FORM_SETTING', dataStorage.value)
                resolve(dataStorage.value)
            }
        })
    },
    getHistoryList({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`/finance/payment_history/${ payloadParams(payload) }`)
                .then(({data}) => {
                    if(typeof data === 'object') {
                        commit('SET_HISTORY_LIST', data.results)
                        commit('SET_HISTORY_COUNT', data.count)
                        resolve(data)
                    } else
                        resolve(false)
                })
                .catch((error) => { reject(error) })
        })
    },
    getPayHistory({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`/finance/online_payment_orders/${ payloadParams(payload) }`)
                .then(({data}) => {
                    if(typeof data === 'object') {
                        commit('SET_PAY_HISTORY', data.results)
                        commit('SET_PAY_HISTORY_COUNT', data.count)
                        resolve(data)
                    } else
                        resolve(false)
                })
                .catch((error) => { reject(error) })
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
